module.exports = __webpack_public_path__ + "img/gd.d0ffda2d.jpg";